import styled from 'styled-components';

// TODO:  max-width: 1140px; convert to variable here and on the List
const styledBody = component => (component ? styled(component) : styled.div)`
  && {
    width: 100%;
    max-width: 1257px;
    margin-left: auto;
    margin-right: auto;
  }
  && > div {
    overflow: initial;
  }
`;

export default styledBody;
